// Brand-wide constants and naming.
export const BRAND_NAME = 'Underlings';
export const BRAND_TAGLINE = "Every member, a personal AI superconnector.";

// Serif typography for titles (from eu-mono convention).
export const TITLE_FONT_STACK =
  '"Cormorant Garamond", "EB Garamond", Georgia, "Times New Roman", serif';

// Google Fonts link tag href — consumers paste into index.html <head>.
export const TITLE_FONT_GOOGLE_URL =
  'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@500;600;700&display=swap';
